import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row lockHeader shinseisyoHeader" }
const _hoisted_2 = {
  class: "subheader-block ml-auto demo col-md-6",
  style: {"text-align":"right"}
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_8 = { class: "panel-container show" }
const _hoisted_9 = { class: "panel-content contents" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-secondary"
}
const _hoisted_11 = { class: "d-flex flex-start w-100" }
const _hoisted_12 = { class: "d-flex flex-fill" }
const _hoisted_13 = { class: "flex-fill" }
const _hoisted_14 = {
  key: 0,
  class: "h5"
}
const _hoisted_15 = {
  key: 1,
  class: "h5"
}
const _hoisted_16 = { class: "m-0" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-10 contCnt" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-10 contCnt" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-10 contCnt" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-10 contCnt" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-10 contCnt" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-10 contCnt" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-10 contCnt" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-10 contCnt" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-10 contCnt" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-10 contCnt" }
const _hoisted_39 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_40 = { class: "panel-container show" }
const _hoisted_41 = {
  class: "panel-content contents",
  style: {"padding":"0"}
}
const _hoisted_42 = { class: "bg-subtlelight-fade custom-scroll" }
const _hoisted_43 = { class: "ml-3" }
const _hoisted_44 = {
  href: "javascript:void(0);",
  title: "Lisa Hatchensen",
  class: "d-block fw-700 text-dark"
}
const _hoisted_45 = { class: "col-lg-8" }
const _hoisted_46 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_47 = { class: "panel-container show" }
const _hoisted_48 = { class: "panel-content contents" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-12 contCnt" }
const _hoisted_51 = { class: "btn-group btn-group-sm requestbtnFrame" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = {
  class: "btn-group btn-group-sm requestbtnFrame",
  style: {"margin-left":"5px"}
}
const _hoisted_55 = {
  class: "row",
  id: "frame-kyuujitu",
  style: {"border-top":"1px solid rgb(229, 229, 229)","border-bottom":"1px solid rgb(229, 229, 229)","padding-top":"10px","margin-top":"10px"}
}
const _hoisted_56 = ["disabled", "onClick"]
const _hoisted_57 = { class: "thumlWrap" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = {
  key: 0,
  class: "text-right",
  style: {"margin-bottom":"10px"}
}
const _hoisted_60 = { class: "fileinfo fileinfo-name" }
const _hoisted_61 = { class: "fileinfo fileinfo-ver" }
const _hoisted_62 = { class: "fileinfo fileinfo-size" }
const _hoisted_63 = { class: "col-md-12 contTitle" }
const _hoisted_64 = {
  id: "frame-img",
  style: {"box-shadow":"0 0 0.5cm rgba(0, 0, 0, 0.5)","margin":"0 auto","width":"80%","margin-top":"20px"}
}
const _hoisted_65 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center","max-width":"400px","width":"80%","height":"710px","margin":"0 auto"}
}
const _hoisted_66 = { class: "panel-container" }
const _hoisted_67 = {
  key: 0,
  class: "fw-700 text-capitalize color-danger-300"
}
const _hoisted_68 = { style: {"width":"100%","height":"70vh","background-color":"white","border":"1px solid #e0e0e0"} }
const _hoisted_69 = { class: "panel-container" }
const _hoisted_70 = { style: {"width":"100%","height":"70vh","background-color":"white","border":"1px solid #e0e0e0"} }
const _hoisted_71 = { class: "text-success fw-500" }
const _hoisted_72 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_CurrencyInput = _resolveComponent("Mo_CurrencyInput")!
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_Or_pdfviewer = _resolveComponent("Or_pdfviewer")!
  const _component_dropzone = _resolveComponent("dropzone")!
  const _component_Mo_modal_max_force = _resolveComponent("Mo_modal_max_force")!
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", {
    id: "js-page-content",
    role: "main",
    class: _normalizeClass(["page-content", {
      isEdit: _ctx.isEditMode,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "subheader col-md-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, " 文書詳細 ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.upd(false)))
            }, _cache[24] || (_cache[24] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("登録 ")
            ]), 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/doclist')))
        }, _cache[25] || (_cache[25] = [
          _createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1),
          _createTextVNode("戻る ")
        ]), 8, _hoisted_4)
      ])
    ]),
    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "lockHeaderSpacer" }, "　", -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[42] || (_cache[42] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "詳細情報"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              (
                  _ctx.delegate.c_claim_id != null ||
                  _ctx.delegate.c_request_expenses_id != null
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
                        _createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                          _createElementVNode("i", { class: "fal fa-info-circle" })
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          (_ctx.delegate.c_request_expenses_id != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "この文書は経費精算書の領収書です"))
                            : _createCommentVNode("", true),
                          (_ctx.delegate.c_claim_id != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "この文書は当システムで発行された請求書です"))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_16, [
                            (_ctx.delegate.c_request_expenses_id != null)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-primary waves-effect waves-themed",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo(_ctx.delegate.link4Expensess!, $event)))
                                }, _cache[27] || (_cache[27] = [
                                  _createElementVNode("span", { class: "fal fa-external-link-square mr-1" }, null, -1),
                                  _createTextVNode("経費精算書 ")
                                ])))
                              : _createCommentVNode("", true),
                            (_ctx.delegate.c_claim_id != null)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "btn btn-primary waves-effect waves-themed",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo(_ctx.delegate.link4Claim!, $event)))
                                }, _cache[28] || (_cache[28] = [
                                  _createElementVNode("span", { class: "fal fa-external-link-square mr-1" }, null, -1),
                                  _createTextVNode("請求書 ")
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "文書番号", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKouzaCd",
                    class: "form-control form-control-sm",
                    disabled: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.delegate.c_doc_id) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_doc_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "文書種別", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4DocManageType,
                    modelValue: _ctx.delegate.c_doc_managtype,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.delegate.c_doc_managtype) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "文書種類", -1)),
                _createElementVNode("div", _hoisted_22, [
                  (
                      _ctx.delegate.c_claim_id != null ||
                      _ctx.delegate.c_request_expenses_id != null
                    )
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        name: "txtKouzaCd",
                        class: "form-control form-control-sm",
                        disabled: "",
                        value: _ctx.cnvDocType2Name()
                      }, null, 8, _hoisted_23))
                    : (_openBlock(), _createBlock(_component_vSelect, {
                        key: 1,
                        options: _ctx.op4DocType,
                        modelValue: _ctx.delegate.c_doc_type,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.delegate.c_doc_type) = $event)),
                        reduce: (label) => label.code
                      }, null, 8, ["options", "modelValue", "reduce"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "登録者", -1)),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKouzaCd",
                    class: "form-control form-control-sm",
                    disabled: "",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.domStaffName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.domStaffName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "金額", -1)),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_Mo_CurrencyInput, {
                    name: "txtKouzaCd",
                    modelValue: _ctx.domPrice,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.domPrice) = $event)),
                    class: "form-control form-control-sm",
                    "decimal-places": 0,
                    "allow-negative": false,
                    showValue: true,
                    disabled: 
                      _ctx.delegate.c_claim_id != null ||
                      _ctx.delegate.c_request_expenses_id != null
                    
                  }, null, 8, ["modelValue", "disabled"]),
                  _cache[34] || (_cache[34] = _createElementVNode("div", {
                    class: "col-md-12 contTitle",
                    style: {"color":"rgb(190, 45, 45)"}
                  }, [
                    _createElementVNode("span", {
                      class: "icon-stack icon-stack-lg",
                      style: {"font-size":"21px"}
                    }, [
                      _createElementVNode("i", { class: "fal fa-info-circle" })
                    ]),
                    _createTextVNode(" 金額は税込み金額を入力してください ")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "取引先", -1)),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKouzaCd",
                    class: "form-control form-control-sm",
                    disabled: _ctx.delegate.c_claim_id != null,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.c_doc_customer) = $event))
                  }, null, 8, _hoisted_30), [
                    [_vModelText, _ctx.delegate.c_doc_customer]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "案件担当者", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.getOpStaffs(),
                    modelValue: _ctx.delegate.c_staff_id4project,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.delegate.c_staff_id4project) = $event)),
                    reduce: (label) => label.c_staff_id,
                    label: "c_staff_name"
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "発行年月日", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_Mt_dtp, {
                    contdate: _ctx.domConsDate,
                    "onUpdate:contdate": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.domConsDate) = $event)),
                    holidays: _ctx.delegate4list,
                    "onUpdate:holidays": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.delegate4list) = $event)),
                    class: "notClear"
                  }, null, 8, ["contdate", "holidays"])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "有効/無効", -1)),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.opEnable,
                    modelValue: _ctx.delegate.c_doc_flag_enab,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.delegate.c_doc_flag_enab) = $event)),
                    label: "label",
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "備考", -1)),
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "txtComment",
                    class: "form-control heightup",
                    style: {"height":"150px"},
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.domRemarks) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.domRemarks]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _cache[44] || (_cache[44] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "変更履歴"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_40, [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                (
                    _ctx.delegate.items4History != null &&
                    _ctx.delegate.items4History.length > 0
                  )
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.delegate.items4History, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex flex-row px-3 pt-3 pb-2",
                        key: item.c_history_id!
                      }, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("a", _hoisted_44, _toDisplayString(_ctx.cnvLogdata2Str(item)), 1),
                          _createTextVNode(" " + _toDisplayString(item.c_history_det), 1)
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("更新履歴はありません")
                    ], 64))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "プレビュー"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_47, [
            _cache[54] || (_cache[54] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      disabled: 
                        _ctx.delegate.c_claim_id != null ||
                        _ctx.delegate.c_request_expenses_id != null
                      ,
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showModal4FileUpByUpd()))
                    }, _cache[45] || (_cache[45] = [
                      _createElementVNode("span", { class: "fal fa-upload mr-1" }, null, -1),
                      _createTextVNode(" アップロード")
                    ]), 8, _hoisted_52),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      disabled: _ctx.item4main.c_docfile_id == null,
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.dlFile()))
                    }, _cache[46] || (_cache[46] = [
                      _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
                      _createTextVNode(" ダウンロード ")
                    ]), 8, _hoisted_53)
                  ]),
                  _cache[49] || (_cache[49] = _createStaticVNode("<div class=\"btn-group btn-group-sm requestbtnFrame\" style=\"margin-left:5px;\" data-v-315eed68><button type=\"button\" class=\"btn btn-primary waves-effect waves-themed requestbtn\" disabled data-v-315eed68><span class=\"fal fa-undo mr-1\" data-v-315eed68></span></button><button type=\"button\" class=\"btn btn-primary waves-effect waves-themed requestbtn\" disabled data-v-315eed68><span class=\"fal fa-redo mr-1\" data-v-315eed68></span></button></div>", 1)),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.zoomIn()))
                    }, _cache[47] || (_cache[47] = [
                      _createElementVNode("span", { class: "fal fa-search-plus mr-1" }, null, -1)
                    ])),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.zoomOut()))
                    }, _cache[48] || (_cache[48] = [
                      _createElementVNode("span", { class: "fal fa-search-minus mr-1" }, null, -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    (
                        _ctx.delegate.items4docFile != null &&
                        _ctx.delegate.items4docFile.length
                      )
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.delegate.items4docFile, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["thuml", {
                          isActiv: item.c_docfile_id == _ctx.item4main.c_docfile_id,
                        }]),
                            style: {"width":"10%"},
                            key: item.c_docfile_id!,
                            disabled: _ctx.btnDisable,
                            onClick: ($event: any) => (_ctx.chgMainImg(item))
                          }, [
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_Or_pdfviewer, {
                                item: item,
                                isOne: true
                              }, null, 8, ["item"])
                            ])
                          ], 10, _hoisted_56))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                (
                    _ctx.item4main.url4Show != null &&
                    _ctx.item4main.url4Show != '' &&
                    _ctx.showItem4main
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("span", _hoisted_60, [
                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "fileinfoTitle" }, [
                          _createElementVNode("i", { class: "fal fa-file-alt" }),
                          _createTextVNode("ファイル名：")
                        ], -1)),
                        _createTextVNode(_toDisplayString(_ctx.item4main.c_docfile_filename), 1)
                      ]),
                      _createElementVNode("span", _hoisted_61, [
                        _cache[51] || (_cache[51] = _createElementVNode("span", { class: "fileinfoTitle" }, [
                          _createElementVNode("i", { class: "fal fa-code-branch" }),
                          _createTextVNode("バージョン:")
                        ], -1)),
                        _createTextVNode(_toDisplayString(_ctx.item4main.c_docfile_ver), 1)
                      ]),
                      _createElementVNode("span", _hoisted_62, [
                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "fileinfoTitle" }, [
                          _createElementVNode("i", { class: "fal fa-expand-arrows-alt" }),
                          _createTextVNode("サイズ：")
                        ], -1)),
                        _createTextVNode(_toDisplayString(_ctx.item4main.c_docfile_size), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    (
                        _ctx.item4main.url4Show != null &&
                        _ctx.item4main.url4Show != '' &&
                        _ctx.showItem4main
                      )
                      ? (_openBlock(), _createBlock(_component_Or_pdfviewer, {
                          key: 0,
                          item: _ctx.item4main
                        }, null, 8, ["item"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_65, _cache[53] || (_cache[53] = [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              style: {"text-align":"center","color":"#3b31a1"},
                              class: "h2"
                            }, " 画像読み込み中・・・ "),
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: "/img/backgrounds/imgloading.svg",
                                alt: "",
                                style: {"width":"100%"}
                              })
                            ])
                          ], -1)
                        ])))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_max_force, { ref: "Mo_modal_fileup" }, {
      title: _withCtx(() => _cache[56] || (_cache[56] = [
        _createTextVNode("ファイルアップロード")
      ])),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          _cache[57] || (_cache[57] = _createElementVNode("div", { class: "loader" }, [
            _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
          ], -1)),
          (!_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, " まずはファイルのアップロードから始めます... "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_dropzone, {
              fileInfo: _ctx.fileInfo,
              updateFileInfo: _ctx.updateFileInfo
            }, null, 8, ["fileInfo", "updateFileInfo"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary waves-effect waves-themed",
              "data-dismiss": "modal",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closeModal4FileUp()))
            }, " 閉じる "))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-secondary waves-effect waves-themed",
              "data-dismiss": "modal",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$router.push('/doclist')))
            }, " 戻る "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_l, { ref: "Mo_modal_fileup4upd" }, {
      title: _withCtx(() => _cache[58] || (_cache[58] = [
        _createTextVNode("ファイルアップロード")
      ])),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_69, [
          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "loader" }, [
            _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
          ], -1)),
          _createElementVNode("div", _hoisted_70, [
            _createVNode(_component_dropzone, {
              fileInfo: _ctx.fileInfo4Upd,
              updateFileInfo: _ctx.updateFileInfo4Upd
            }, null, 8, ["fileInfo", "updateFileInfo"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary waves-effect waves-themed",
              "data-dismiss": "modal",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.closeModal4FileUpByUpd()))
            }, " 閉じる "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[22] || (_cache[22] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _cache[60] || (_cache[60] = _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)),
        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => _cache[61] || (_cache[61] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[62] || (_cache[62] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[63] || (_cache[63] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[64] || (_cache[64] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("button", {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}